import {queryOptions, useQuery} from '@tanstack/react-query';

import api, {type Configs, type ConfigParams} from '@/api/configService';

const patchConfigServiceConfig = (config: Configs): Configs => {
  return {
    ...config,
    // We don't need link masking, because our pages aren't indexed by search-engines.
    // But we want to use the same config as SEARCH (which enables link masking).
    // So we override "masked" here to always be false.
    // @FIXME is this necessary? why don't we do it for the sub menu items aswell?
    headers: config.headers.map((header) => ({
      ...header,
      menu: header.menu
        ? {
            ...header.menu,
            items: header.menu.items.map((item) => ({
              ...item,
              link: item.link ? {...item.link, masked: false} : undefined,
            })),
          }
        : undefined,
    })),
  };
};

export const configServiceConfigQuery = (params: ConfigParams) => {
  return queryOptions({
    queryKey: ['config-service', 'config', params],
    queryFn: async ({signal}) => {
      const response = await api.config(params, {signal});
      if (response.status !== 200) {
        throw new Error(
          (response.data?.message as string) ||
            'Unknown error while fetching config from config-service'
        );
      }
      return patchConfigServiceConfig(response.data);
    },
  });
};

export const configServiceConfigQueryDefaultParams = (): ConfigParams => ({
  agent: import.meta.env.VITE_PORTAL,
  pageTypes: ['ibe'],
});

export const useConfigServiceConfig = (
  params: ConfigParams = configServiceConfigQueryDefaultParams()
) => {
  return useQuery(configServiceConfigQuery(params));
};
